<template>
  <div class="page-header">
    <div class="page-header__text">
      <h2 class="page-header__title">{{ title }}</h2>
      <p v-if="subtitle" class="page-header__subtitle">{{ subtitle }}</p>
    </div>

    <div class="page-header__actions">
      <english-fields-toggle v-if="englishToggle"></english-fields-toggle>
      <v-btn v-if="createUrl" class="btn-primary" depressed @click="$router.push(createUrl)">
        <v-icon left>mdi-plus</v-icon>
        ثبت جدید
      </v-btn>
      <v-btn v-if="$route.path !== '/'" class="btn-secondary" outlined @click="$router.go(-1)">
        بازگشت
        <v-icon right>mdi-arrow-left</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import EnglishFieldsToggle from "@/components/General/EnglishFieldsToggle.vue";

export default {
  name: "PageHeader",

  components: {EnglishFieldsToggle},

  props: {
    title: String,
    createUrl: String,
    subtitle: String,
    // Pages with English inputs show the button that reveals them.
    englishToggle: Boolean,
  },
}
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 24px 0;
}

.page-header__title {
  font-size: 24px;
  line-height: 1.4;
  position: relative;
  padding-bottom: 10px;
}

.page-header__title::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 48px;
  height: 3px;
  border-radius: 3px;
  background: #00ADB5;
}

.page-header__subtitle {
  margin: 8px 0 0;
  color: #aab2bd;
  font-size: 14px;
}

.page-header__actions {
  display: flex;
  gap: 12px;
}

@media (max-width: 600px) {
  .page-header {
    padding: 16px 0;
  }

  .page-header__title {
    font-size: 20px;
  }

  .page-header__actions {
    width: 100%;
  }

  .page-header__actions .v-btn {
    flex: 1 1 0;
  }
}
</style>
